import { BaseMonitorViewPage } from "./view";
import { Options } from "vue-class-component";
import components from "../../components/component";
import { ElLoading } from "element-plus";
import { CloudMonitorBloc } from "../../services/bloc/bloc.cloud";

@Options({
  components: components,
})
export class CloudMonitorViewPage extends BaseMonitorViewPage {
  async created() {
    this.equipmentId = this.$route.params.id;
    const response: any = await this.monitorBloc.getEquipment(this.equipmentId);
    this.equipment = response.data;
    this.equipments.push(this.equipment);
    this.setTabs();
    await this.getAlarm();
    this.fetchMap(this.equipment);
  }

  unmounted(): void {
    this.subscription.alarm.unsubscribe();
  }

  async fetchMap(equipment: any) {
    const response: any = await (
      this.monitorBloc as CloudMonitorBloc
    ).getCloudEquipment(this.equipmentId);
    equipment = response.data;
    try {
      this.map = {
        center: [
          equipment.additional.latitude as number,
          equipment.additional.longitude as number,
        ],
      };
    } catch (e) {}
  }

  async getAlarm() {
    try {
      const userStorage = await this.monitorBloc.getUserStorage();
      const siteStorage = await this.monitorBloc.getSiteStorage();

      this.subscription.alarm = (
        await this.monitorBloc.listenAlarm(userStorage.id, siteStorage.id)
      ).subscribe(async (alarm: any) => {
        if (!alarm) return;
        this.equipment.sensors = this.equipment.sensors.map((sensor) => {
          if (sensor.id != alarm.sensor_id) return sensor;
          const isSame = alarm.created_at == sensor.alarm_created_at;
          return {
            ...sensor,
            alarm: isSame ? sensor.alarm : alarm.alarm_popup == "yes",
            message: isSame ? sensor.message : alarm.message,
            alarm_type: isSame ? sensor.alarm_type : alarm.alarm_type,
            alarm_created_at: isSame
              ? sensor.alarm_created_at
              : alarm.created_at,
          };
        });
      });
    } catch (error) {
      console.log(error);
    }
  }
}
